const KeenSlider = window.KeenSlider

const { useA11y, useAutoplay, useDots } = window.BAO.Carousel.plugins

class HeroCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (this.els.slide.elements.length < 2) return

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    this.onSlideChanged = this.onSlideChanged.bind(this)

    return new KeenSlider(
      this,
      {
        selector: this.els.slide.selector,
        loop: true,
        renderMode: 'custom',
        slideChanged: this.onSlideChanged,
      },
      [
        useA11y(),
        useAutoplay(5, { pauseOnHover: false }),
        useDots(this.els?.dot?.elements),
      ],
    )
  }

  onSlideChanged (instance) {
    const currentSlide = instance.track.details.rel

    this.els.slide.elements.forEach((slide, index) => {
      slide.setAttribute('aria-hidden', index !== currentSlide)
    })
  }
}

if (!customElements.get('hero-carousel')) {
  customElements.define('hero-carousel', HeroCarousel)
}
